import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import Footer from './components/Footer';

import Navbar from './components/Navbar';

import Home from './pages/Home';
import PastQuestion from './pages/PastQuestion';
import Subject from './pages/Subject';
import Waec from './pages/Waec'
import Jamb from './pages/Jamb';
import Neco from './pages/Neco';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
    
        <Navbar/>
     <Routes>
      {/* main */}
       <Route path='/' element={ <Home/>} />
       <Route path='/pastQuestion' element={ <PastQuestion/>} />
       <Route path='/subject' element={ <Subject/>} />


       {/* past question */}
       <Route path='/waec' element={ <Waec/>} />
       <Route path='/jamb' element={ <Jamb/>} />
       <Route path='/neco' element={ <Neco/>} />
       <Route path='/' element={ <Home/>} />



       {/* past question subjects */}
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />

        {/* syllabus subjects */}
        <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
       <Route path='/' element={ <Home/>} />
      </Routes>
      <footer> <Footer/> </footer>
      </BrowserRouter>
    </div>

  
  );
}

export default App;
